import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AccountStatus } from 'api/account';
import { getAccountState } from 'data/account';
import { useAccountDataQuery } from 'queries/account';
export const useAccount = ()=>{
    const { data } = useSelector(getAccountState);
    if (!data) {
        throw new Error('Account is unavailable');
    }
    return data;
};
/**
 * Billing is enabled only if subscription is present
 * under billing meta returned in init call
 */ export const useBillingFeatureFlag = ()=>{
    const { data: accountData } = useAccountDataQuery();
    const subscription = useMemo(()=>{
        var _accountData_billingMeta;
        return accountData === null || accountData === void 0 ? void 0 : (_accountData_billingMeta = accountData.billingMeta) === null || _accountData_billingMeta === void 0 ? void 0 : _accountData_billingMeta.subscription;
    }, [
        accountData
    ]);
    return !!subscription;
};
export const useIsAccountActiveWithoutBilling = ()=>{
    const { status, expiryDate } = useAccount();
    return useMemo(()=>status !== AccountStatus.Suspended && (![
            AccountStatus.Trial,
            AccountStatus.Grace
        ].includes(status) || moment(expiryDate).isSameOrAfter(moment().format('YYYY-MM-DD'))), [
        status,
        expiryDate
    ]);
};
export const useIsAccountActive = ()=>{
    const isBillingEnabled = useBillingFeatureFlag();
    const isAccActive = useIsAccountActiveWithoutBilling();
    return useMemo(()=>!isBillingEnabled || // return true if billing is not enabled.
        isAccActive, [
        isBillingEnabled,
        isAccActive
    ]);
};
